import { Link, useParams } from "react-router-dom"
import jwt_decode from 'jwt-decode';

const SideNav = () => {

    const { id } = useParams();


    const logCheck = localStorage.getItem("data");
    let decoded_data = ""
    if (logCheck != null) {
        decoded_data = jwt_decode(logCheck)
    }

    return (
        <div>
            {/* Main Sidebar Container */}
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                {/* Brand Logo */}
                <Link to="/" className="brand-link" style={{
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}>
                    <img src="logo.png" alt="AdminLTE Logo" className="elevation-1" style={{ padding: 5, borderRadius: "10%" }} />
                    {/* <div className="brand-text font-weight-light ml-2">ASK US</div> */}
                </Link>
                {/* Sidebar */}
                <div className="sidebar" style={{
                    height: `calc(100vh - (10.5rem + 1px))`
                }}>
                    {/* Sidebar user panel (optional) */}
                    <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                        <div className="image">
                            <img src="dist/img/user2-160x160.jpg" className="img-circle elevation-2" alt="User Image" />
                        </div>
                        <div className="info">
                            <a href="#" className="d-block">{decoded_data.user.name}</a>
                        </div>
                    </div>



                    {/* Sidebar Menu */}
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            <li className="nav-item">
                                <Link to='/' className="nav-link">
                                    <i className="nav-icon fas fa-tachometer-alt" />
                                    <p>
                                        Dashboard
                                    </p>
                                </Link>
                            </li>

                            <li className="nav-header">Data</li>
                            <li className="nav-item">
                                <Link to='/banner' className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>
                                        Banner
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to='/unit' className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>
                                        Unit
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to='/mainService' className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>
                                        Category
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to='/service' className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>
                                        Sub-Category
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to='/serviceCategory' className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>
                                        Service
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to='/uploadImage' className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>
                                        Upload Images
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to='/workingDay' className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>
                                        Working Days
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>

                        </ul>
                    </nav>
                </div>
            </aside>

        </div>
    )
}

export default SideNav